import { Data_getInstance2muox7fllvisv as Data_getInstance } from './adapter/SavePairAssignmentsMutation_ResponseAdapter.mjs';
import { getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { SavePairAssignmentsMutation_VariablesAdapter_instance3i8c5cz7hcsqp as SavePairAssignmentsMutation_VariablesAdapter_instance } from './adapter/SavePairAssignmentsMutation_VariablesAdapter.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
import { ApolloAdaptableWith1g871415y7ifs as ApolloAdaptableWith } from '../../../../../../apollo-kotlin-apollo-annotations/com/apollographql/apollo/annotations/ApolloAdaptableWith.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(savePairAssignments) {
        this.a6i_1 = savePairAssignments;
      }
      toString() {
        return 'Data(savePairAssignments=' + this.a6i_1 + ')';
      }
      hashCode() {
        return this.a6i_1 == null ? 0 : getBooleanHashCode(this.a6i_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!(this.a6i_1 == other.a6i_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.b6i_1 = 'b177b922ea7e084a060efcefb01d21964d1902cda25617294c2e1bcfe587b840';
        this.c6i_1 = 'savePairAssignments';
      }
      h6g() {
        return 'mutation savePairAssignments($input: SavePairAssignmentsInput!) { savePairAssignments(input: $input) }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var SavePairAssignmentsMutationClass;
function SavePairAssignmentsMutation() {
  if (SavePairAssignmentsMutationClass === VOID) {
    class $ {
      constructor(input) {
        this.d6i_1 = input;
      }
      j6g() {
        return 'b177b922ea7e084a060efcefb01d21964d1902cda25617294c2e1bcfe587b840';
      }
      operationId() {
        return this.j6g();
      }
      x48() {
        return Companion_instance.h6g();
      }
      k6g() {
        return 'savePairAssignments';
      }
      operationName() {
        return this.k6g();
      }
      r47(writer, customScalarAdapters, withDefaultValues) {
        SavePairAssignmentsMutation_VariablesAdapter_instance.e6i(writer, this, customScalarAdapters, withDefaultValues);
      }
      q47() {
        return obj(Data_getInstance());
      }
      toString() {
        return 'SavePairAssignmentsMutation(input=' + this.d6i_1.toString() + ')';
      }
      hashCode() {
        return this.d6i_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePairAssignmentsMutation()))
          return false;
        if (!this.d6i_1.equals(other.d6i_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePairAssignmentsMutation', VOID, VOID, [Mutation()]);
    SavePairAssignmentsMutationClass = $;
  }
  return SavePairAssignmentsMutationClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Data as Data2n9h8mazd823k,
  SavePairAssignmentsMutation as SavePairAssignmentsMutation1xoyawurksq0m,
};
//endregion

//# sourceMappingURL=SavePairAssignmentsMutation.mjs.map
